import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useTeamUsers(teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['team-users', teamId],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          // Temporarily remove audience requirement to test
          // audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get(`/users/team/${teamId}`)
      return response.data
    },
    enabled: !!teamId,
  })
}
